<!--
+------------------------------------------------------------------+
| Author: Jeffrey Thümann                                          |
| Component: SuggestedBlogPost                                     |
| Section: components                                              |
| Purpose: Suggested-article card used in blog recommendation rows.|
+------------------------------------------------------------------+
-->
<template>
    <a :href="url" class="suggested_blog_post" @mouseenter="applyRandomCardHover"
        @mouseleave="resetRandomCardHover">
        <div class="suggested_blog_post_image" :style="{ backgroundImage: thumbnailUrl, transform: hoverTransform }"></div>
        <p>{{ label }}</p>
    </a>
</template>

<script>
import { useRandomCardHover } from '@/composables/useRandomCardHover';
import { getBackgroundImageUrl } from '@/utils/mediaUtils';

export default {
    name: 'SuggestedBlogPost',
    setup() {
        return useRandomCardHover();
    },
    props: {
        label: {
            type: String,
            required: true
        },
        thumbnail: {
            type: String,
            required: true
        },
        url: {
            type: String,
            required: true
        }
    },
    computed: {
        thumbnailUrl() {
            return getBackgroundImageUrl(this.thumbnail);
        }
    }
};
</script>

<style scoped>
.suggested_blog_post {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-self: stretch;
    align-items: flex-start;
    gap: 16px;
    flex-shrink: 0;
    text-decoration: none;
    cursor: pointer;
    transition: all .6s cubic-bezier(.49, 1.42, .25, 1.53);
}

.suggested_blog_post p {
    text-decoration: none;
}

.suggested_blog_post:hover p {
    text-decoration: underline;
}

.suggested_blog_post_image {
    border-radius: 4px;
    border: 2px solid var(--brand-text-dark);
    background-repeat: no-repeat;
    background-size: 105%;
    background-position: center;
    box-shadow: var(--shadow-card-sm);
    width: 100%;
    padding-bottom: 64.86%;
    transition: var(--transition-bounce);
}

.suggested_blog_post:hover .suggested_blog_post_image {
    background-size: 115%;
}

.suggested_blog_post p {
    font-weight: 600;
    color: var(--brand-text-dark);
}
</style>
